import React, { useState } from "react";

const AlumniAppFAQ = [
  {
    question: "What is the Alumni App?",
    answer:
      "The Alumni App is a platform designed to connect graduates of a particular institution, allowing them to stay in touch, network, and engage with their alma mater.",
  },
  {
    question: "How can the Alumni App benefit me as a graduate?",
    answer:
      "The Alumni App provides numerous benefits, including opportunities for networking with fellow alumni, staying updated on alumni events and news, accessing career resources, and maintaining connections with your alma mater and former classmates.",
  },
  {
    question: "Is the Alumni App easy to use?",
    answer:
      "Yes, the Alumni App is designed with user-friendliness in mind. Its intuitive interface makes it simple for users to navigate and utilize its various features.",
  },
  {
    question: "Can the Alumni App integrate with social media platforms?",
    answer:
      "Certainly, the Alumni App can integrate with popular social media platforms, allowing seamless connectivity and sharing of alumni-related content.",
  },
  {
    question: "How secure is the Alumni App?",
    answer:
      "Security is a top priority for us. The Alumni App employs advanced security measures to safeguard user data and ensure a safe and trusted environment for alumni engagement.",
  },
];
const FAQComp = () => {
    const [openFAQ, setOpenFAQ] = useState(null)

    const onRowSelect = (rowId) => {
        if (openFAQ == null) {
            setOpenFAQ(rowId)
        } else if (openFAQ == rowId) {
            setOpenFAQ(null)
        } else if (openFAQ != rowId) {
            setOpenFAQ(rowId)
        }
    }

  return (
    <div className="faq_comp">
      <div className="container">
        <div className="comp_header">
          <h1>Frequently Asked Questions</h1>
          <p>
          "Our AI writing service is your go-to solution for crafting professional content tailored to alumni needs. Whether it's articles, blog posts, or marketing copy, we help alumni create high-quality written material effortlessly, fostering connections and engagement within the alumni community."
          </p>
        </div>
        <div className="faq_wrapper">
          {AlumniAppFAQ?.map((data, idx) => (
            <div className={openFAQ == data?.question?"faq_card active":"faq_card"}>
              <div className="first" onClick={()=>onRowSelect(data?.question)}>
                <h3>{data?.question}</h3>
                <i class="fa-solid fa-chevron-down"></i>
              </div>
              <div className="second">{data?.answer}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQComp;
